"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Upload;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Upload(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "upload"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,58.955a2.5,2.5,0,0,0-2.5,2.5v17.5h-75v-17.5a2.5,2.5,0,0,0-5,0v20a2.5,2.5,0,0,0,2.5,2.5H90a2.5,2.5,0,0,0,2.5-2.5v-20A2.5,2.5,0,0,0,90,58.955Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.194,40.7,47.5,24.391V63.45a2.5,2.5,0,0,0,5,0V24.392L68.805,40.7a2.5,2.5,0,1,0,3.535-3.535L52.083,16.9a2.957,2.957,0,0,0-4.171,0L27.659,37.161A2.5,2.5,0,1,0,31.194,40.7Z"
  })))));
}